import { useEffect } from 'react';
import { Link, Outlet, ScrollRestoration } from 'react-router-dom';
import { useAppDispatch } from '@/shared/hooks/redux';
import { clearError } from '@/shared/store/authSlice';
import nebiLogo from '@/assets/images/nebi-branco.png';
// `ensino.jpg` original tem 15 MB: esta é a mesma foto a 1400px/171 KB.
import asidePhoto from '@/assets/images/auth-aside.jpg';
import styles from './AuthLayout.module.scss';

const QUOTE = '“Lâmpada para os meus pés é a tua palavra.”';
const QUOTE_SOURCE = 'SALMOS 119.105';

/** Shell das 4 telas de auth: split foto + coluna de 420px, sem header/footer do site. */
export const AuthLayout = () => {
  const dispatch = useAppDispatch();

  // `auth.error` é compartilhado por todos os thunks; limpar na entrada evita herdar erro alheio.
  useEffect(() => {
    dispatch(clearError());
  }, [dispatch]);

  return (
    <div className={styles.root} data-ds="nebi">
      <ScrollRestoration />

      <aside className={styles.aside}>
        <img
          src={asidePhoto}
          alt=""
          aria-hidden="true"
          className={styles.photo}
          loading="eager"
          decoding="async"
        />
        <div aria-hidden="true" className={styles.overlay} />

        <Link to="/home" className={styles.logoLink}>
          <img src={nebiLogo} alt="NEBI — voltar ao início" className={styles.logo} />
        </Link>

        <div className={styles.quoteBlock}>
          <p className={styles.quote}>{QUOTE}</p>
          <span className={styles.quoteSource}>{QUOTE_SOURCE}</span>
        </div>
      </aside>

      <main className={styles.main}>
        <div className={styles.column}>
          <Outlet />
          <p className={styles.legal}>
            Ao continuar, você concorda com os Termos de uso e a Política de privacidade do NEBI.
          </p>
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
